// production environment, this file replaces the environment.ts when building for production
export const environment = {
    googleTagManagerContainer: 'GTM-MLHV83',
    googleTagManagerEnvironment: '',
    googleTagManagerEnvironmentAuth: '',
};
